(() => {
  // ===== Root / Elements =====
  const $root = document.querySelector('[data-ats-delivery]');
  if (!$root) return;

  const $ = (sel) => $root.querySelector(sel);

  const $input = $('[data-ats-delivery-input]');
  const $button = $('[data-ats-delivery-btn]');
  const $message = $('[data-ats-delivery-msg]');

  // Style-1 (tabs + timelines)
  const $tabs = $('[data-ats-delivery-tabs]');
  const $tabBtns = $root.querySelectorAll('[data-ats-tab-btn]');
  const $tabPanels = $root.querySelectorAll('[data-ats-tab-panel]');
  const $timelineFast = $('[data-ats-delivery-timeline-fast]');
  const $timelineStd = $('[data-ats-delivery-timeline-std]');

  // Style-2 (2 lines summary)
  const $summary = $('[data-ats-delivery-summary]');
  const $summaryStd = $('[data-ats-summary-std]');
  const $summaryFast = $('[data-ats-summary-fast]');

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  // ===== Settings from data-* =====
  const csvUrl = ($root.dataset.csv || '').trim();
  const dateFormat = ($root.dataset.format || 'MMM_DD').trim();

  const TEXT_LOADING = $root.dataset.loading || 'Checking...';
  const TEXT_INVALID = $root.dataset.invalid || 'Please enter a valid 6-digit pincode.';
  const TEXT_NOTFOUND = $root.dataset.notfound || 'Sorry, delivery is not available to this pincode.';

  const MODE_STD = $root.dataset.modeStd || 'Standard Delivery';
  const MODE_FAST = $root.dataset.modeFast || 'Express Delivery';

  const LABEL_ORDERED = $root.dataset.l1 || 'Ordered';
  const LABEL_SHIPPED = $root.dataset.l2 || 'Shipped';
  const LABEL_DELIVERED = $root.dataset.l3 || 'Delivered';

  // UI style switch (style1 = current, style2 = 2 lines)
  const UI_STYLE = ($root.dataset.uiStyle || 'style1').trim(); // "style1" | "style2"

  const productPinCollections = (($root.dataset.collections || '').trim())
    .split(',')
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean)
    .filter((h) => h.startsWith('pin-')); // ✅ only pin-* collections

  const isCollectionScope = (scope) => (scope || '').toLowerCase().startsWith('collection:');
  const scopeHandle = (scope) => (scope || '').split(':').slice(1).join(':').trim().toLowerCase();

  if (!csvUrl || !$input || !$button || !$message) return;

  // For style1 we need timelines
  if (UI_STYLE === 'style1' && (!$timelineFast || !$timelineStd)) return;

  // For style2 we need summary containers
  if (UI_STYLE === 'style2' && (!$summary || !$summaryStd || !$summaryFast)) return;

  // ===== Helpers =====
  const PIN_REGEX = /^[0-9]{6}$/;

  const setMessage = (text) => ($message.textContent = text || '');

const clearUI = () => {
  if ($timelineFast) $timelineFast.innerHTML = '';
  if ($timelineStd) $timelineStd.innerHTML = '';
  if ($tabs) $tabs.style.display = 'none';

  if ($summary) $summary.style.display = 'none';

  // ✅ clear only the span text (do NOT remove img/span)
  const stdSpan = $summaryStd?.querySelector('span');
  const fastSpan = $summaryFast?.querySelector('span');
  if (stdSpan) stdSpan.textContent = '';
  if (fastSpan) fastSpan.textContent = '';
};


  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + Number(days || 0));
    return d;
  };

  const formatDate = (d) => {
    const day = String(d.getDate()).padStart(2, '0');
    const monShort = d.toLocaleString('en-US', { month: 'short' });
    const monNum = String(d.getMonth() + 1).padStart(2, '0');
    const yr = d.getFullYear();

    if (dateFormat === 'DD_MMM') return `${day} ${monShort}`;
    if (dateFormat === 'DD_MM_YYYY') return `${day}/${monNum}/${yr}`;
    return `${monShort} ${day}`; // MMM_DD
  };

  // ===== Tabs (style1) =====
  const setActiveTab = (key) => {
    $tabBtns.forEach((b) => b.classList.toggle('is-active', b.dataset.atsTabBtn === key));
    $tabPanels.forEach((p) => p.classList.toggle('is-active', p.dataset.atsTabPanel === key));
    localStorage.setItem('ats_delivery_tab', key);
  };

  if ($tabBtns?.length) {
    $tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => setActiveTab(btn.dataset.atsTabBtn));
    });
  }

  // ===== Robust CSV line parser (handles quotes + commas inside quotes) =====
  const parseCSVLine = (line) => {
    const out = [];
    let cur = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const ch = line[i];

      if (ch === '"') {
        // handle escaped quote ""
        if (inQuotes && line[i + 1] === '"') {
          cur += '"';
          i++;
        } else {
          inQuotes = !inQuotes;
        }
        continue;
      }

      if (ch === ',' && !inQuotes) {
        out.push(cur.trim());
        cur = '';
        continue;
      }

      cur += ch;
    }

    out.push(cur.trim());
    return out;
  };

  const parseCSVToObjects = (csvText) => {
    const lines = csvText.replace(/\r/g, '').split('\n').filter(Boolean);
    if (!lines.length) return [];

    const header = parseCSVLine(lines[0]).map((h) => (h || '').toLowerCase());

    const idxScope = header.indexOf('product_scope');
    const idxPin = header.indexOf('pincode');
    const idxPrepStd = header.indexOf('prep_std');
    const idxShipStd = header.indexOf('ship_std');
    const idxPrepFast = header.indexOf('prep_fast');
    const idxShipFast = header.indexOf('ship_fast');

    const get = (cells, idx, fallbackIdx) => (cells[idx >= 0 ? idx : fallbackIdx] || '').trim();

    const rows = [];
    for (let i = 1; i < lines.length; i++) {
      const cells = parseCSVLine(lines[i]);
      if (!cells || cells.length < 3) continue;

      const scope = get(cells, idxScope, 0) || '*';

      // IMPORTANT:
      // This expects pincode cell to contain comma-separated pins (no quotes needed normally).
      const pinCell = get(cells, idxPin, 1);
      const pins = pinCell
        .split(',')
        .map((x) => x.trim())
        .filter(Boolean);

      const prepStd = Number(get(cells, idxPrepStd, 2));
      const shipStd = Number(get(cells, idxShipStd, 3));
      const prepFast = Number(get(cells, idxPrepFast, 4));
      const shipFast = Number(get(cells, idxShipFast, 5));

      rows.push({
        scope,
        pins,
        prepStd: Number.isFinite(prepStd) ? prepStd : 0,
        shipStd: Number.isFinite(shipStd) ? shipStd : 0,
        prepFast: Number.isFinite(prepFast) ? prepFast : 0,
        shipFast: Number.isFinite(shipFast) ? shipFast : 0
      });
    }

    return rows;
  };

  let cachedRows = null;

  const fetchDeliveryRows = async () => {
    if (cachedRows) return cachedRows;

    const res = await fetch(csvUrl, { cache: 'no-store' });
    if (!res.ok) throw new Error('CSV_FETCH_FAILED');

    const csvText = await res.text();
    cachedRows = parseCSVToObjects(csvText);
    return cachedRows;
  };

  // ===== Find row for pincode with pin-* collection override =====
  const findDeliveryRow = (rows, pin) => {
    let defaultRow = null;
    let bestOverride = null;

    for (const r of rows) {
      if (!r?.pins?.length) continue;
      if (!r.pins.includes(pin)) continue;

      const scope = (r.scope || '*').trim();

      // default
      if (scope === '*') {
        defaultRow = r;
        continue;
      }

      // collection override only if product has pin-* collection
      if (isCollectionScope(scope)) {
        const handle = scopeHandle(scope);
        if (handle && productPinCollections.includes(handle)) {
          bestOverride = r;
          break; // ✅ override wins
        }
      }
    }

    return bestOverride || defaultRow;
  };

  // ===== UI Render (style1) =====
  const renderTimelineInto = ($target, orderedDate, shippedDate, deliveredDate) => {
    if (!$target) return;

    $target.innerHTML = `
      <div class="ats-delivery__step-marker1">
        <div class="ats-delivery__step">
          <div class="timeline-layout--svg tw-mb-4">
            <img class="timeline-layout--svg--icon timeline-layout--svg--icon--convert-color"
                 src="https://storage.synctrack.io/megamind-estimated/icon-timeline/icon%20svg/order1.svg"
                 alt="order icon" width="20" height="20">
          </div>
          <div class="ats-delivery__title ATS-caption tw-font-medium">${LABEL_ORDERED}</div>
          <div class="ats-delivery__date ATS-caption">${formatDate(orderedDate)}</div>
        </div>
      </div>

      <div class="ats-delivery__step-marker2">
        <div class="ats-delivery__step">
          <div class="timeline-layout--svg tw-mb-4">
            <img class="timeline-layout--svg--icon timeline-layout--svg--icon--convert-color"
                 src="https://storage.synctrack.io/megamind-estimated/icon-timeline/icon%20svg/delivery1.svg"
                 alt="shipped icon" width="20" height="20">
          </div>
          <div class="ats-delivery__title ATS-caption tw-font-medium">${LABEL_SHIPPED}</div>
          <div class="ats-delivery__date ATS-caption">${formatDate(shippedDate)}</div>
        </div>
      </div>

      <div class="ats-delivery__step">
        <div class="timeline-layout--svg tw-mb-4">
          <img class="timeline-layout--svg--icon timeline-layout--svg--icon--convert-color"
               src="https://storage.synctrack.io/megamind-estimated/icon-timeline/icon%20svg/location1.svg"
               alt="delivered icon" width="20" height="20">
        </div>
        <div class="ats-delivery__title ATS-caption tw-font-medium">${LABEL_DELIVERED}</div>
        <div class="ats-delivery__date ATS-caption">${formatDate(deliveredDate)}</div>
      </div>
    `;
  };

  // ===== UI Render (style2) =====
  // const renderSummary = (orderedDate, deliveredStd, deliveredFast) => {
  //   if (!$summary || !$summaryStd || !$summaryFast) return;

  //   const from = formatDate(orderedDate);
  //   const stdTo = formatDate(deliveredStd);
  //   const fastTo = formatDate(deliveredFast);

  //   $summaryStd.textContent = `${MODE_STD}: ${from} - ${stdTo}`;
  //   $summaryFast.textContent = `${MODE_FAST}: ${from} - ${fastTo}`;

  //   $summary.style.display = '';
  // };

const renderSummary = (orderedDate, deliveredStd, deliveredFast) => {
  if (!$summary || !$summaryStd || !$summaryFast) return;

  // force "22 January" style (no year)
  const byText = (d) =>
    d.toLocaleString('en-GB', { day: '2-digit', month: 'long' }); // "22 January"

$summaryStd.querySelector('span').textContent =
  `${MODE_STD} by ${byText(deliveredStd)}`;

$summaryFast.querySelector('span').textContent =
  `${MODE_FAST} by ${byText(deliveredFast)}`;


  $summary.style.display = '';
};



  // ===== Main Action =====
  const checkPincode = async () => {
    const pin = ($input.value || '').trim();

    setMessage('');
    clearUI();

    if (!PIN_REGEX.test(pin)) {
      setMessage(TEXT_INVALID);
      return;
    }

    setMessage(TEXT_LOADING);

    try {
      const rows = await fetchDeliveryRows();
      const row = findDeliveryRow(rows, pin);

      await sleep(400); // slight delay for better UX

      if (!row) {
        setMessage(TEXT_NOTFOUND);
        return;
      }

      const orderedDate = new Date();

      // STANDARD
      const shippedStd = addDays(orderedDate, row.prepStd);
      const deliveredStd = addDays(shippedStd, row.shipStd);

      // EXPRESS (FAST)
      const shippedFast = addDays(orderedDate, row.prepFast);
      const deliveredFast = addDays(shippedFast, row.shipFast);

      // ===== Style decision =====
      if (UI_STYLE === 'style2') {
        renderSummary(orderedDate, deliveredStd, deliveredFast);
        setMessage('');
        localStorage.setItem('ats_delivery_pin', pin);
        return;
      }

      // Style 1 (existing)
      if ($tabs) $tabs.style.display = '';
      renderTimelineInto($timelineStd, orderedDate, shippedStd, deliveredStd);
      renderTimelineInto($timelineFast, orderedDate, shippedFast, deliveredFast);

      const savedTab = localStorage.getItem('ats_delivery_tab');
      setActiveTab(savedTab === 'fast' ? 'fast' : 'std');

      setMessage('');
      localStorage.setItem('ats_delivery_pin', pin);
    } catch (err) {
      console.error(err);
      setMessage(TEXT_NOTFOUND);
    }
  };

  // ===== Events =====
  $button.addEventListener('click', checkPincode);
  $input.addEventListener('keydown', (e) => e.key === 'Enter' && checkPincode());

  // ===== Restore saved pin =====
  const savedPin = localStorage.getItem('ats_delivery_pin');
  if (savedPin && PIN_REGEX.test(savedPin)) $input.value = savedPin;

  console.log('Delivery checker ready.', {
    csvUrl,
    UI_STYLE,
    modes: { MODE_STD, MODE_FAST }
  });
})();
